"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _video = _interopRequireDefault(require("video.js"));
var _lodash = require("lodash");
var _utility = require("./utility");
var _DebugManager = _interopRequireDefault(require("../utils/DebugManager"));
var _constants = require("./constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// videoLibrary can be overriden with a custom JS video library, if desired
// this also makes testing/mocking easier:

var StandardVideoPlayer = function StandardVideoPlayer(videoId, config) {
  var videoLibrary = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _video["default"];
  var dmInstance = _DebugManager["default"].dmInstance;
  var player;
  try {
    player = videoLibrary(videoId, config);
    (0, _utility.setupHooks)(player, config);
    var urls = config.urls;
    setSourceList(urls);
    dmInstance.log('[StandardVideoPlayer] videojs version: ', _video["default"].VERSION);
  } catch (err) {
    dmInstance.log('[StandardVideoPlayer] error: ', err);
  }
  function setSourceList(urls) {
    if (!Array.isArray(urls) || (0, _lodash.isEmpty)(urls)) {
      console.warn('[StandardVideoPlayer] Invalid URLs supplied to the video player.');
      return false;
    }
    var urlList = urls;
    var presentationType = config.presentationType;
    if (presentationType === _constants.PresentationTypes.LIVE) {
      urlList = (0, _utility.processUrls)(urls, config);
    }
    player.src(urlList);
    dmInstance.logMessage([_DebugManager["default"].debugLevel.M], '[StandardVideoPlayer] source urls: ', urls);
    return true;
  }
  var playerPromise = new Promise(function (resolve) {
    resolve(player);
  });
  return playerPromise;
};
var _default = exports["default"] = StandardVideoPlayer;